<template>
    <div class="wineguide-container">
        <div class="itips-head">
            <div class="container">
                <div class="inner-page-title">{{ $t("home-top4") }}</div>
                <div class="inenr-page-breadcrumb">
                    <div class="inner-page-bread-line"></div>
                </div>
            </div>
        </div>
        <div class="container">
            <div class="wine-guide-body">
                <div class="wine-guide-left hide-mobile">
                    <div class="wine-guide-left-title">
                        <nuxt-link class="wine-guide-back"
                                   :to="localePath('/wine-guide/south-africa/stellenbosch')"></nuxt-link>
                        Producers
                    </div>
                    <nuxt-link class="wine-guide-country active"
                               :to="localePath('/wine-guide/south-africa/stellenbosch/alto-wine-estate')">Alto Wine
                        Estate
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/south-africa/stellenbosch/kanonkop-paul-sauer')">Kanonkop
                        Paul Sauer
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/south-africa/stellenbosch/meerlust-estate')">Meerlust Estate
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/south-africa/stellenbosch/savanha-wines')">Savanha Wines
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/south-africa/stellenbosch/the-sadie-family-wines')">The
                        Sadie Family Wines
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/south-africa/stellenbosch/thelema-mountain-vineyards')">
                        Thelema Mountain Vineyards
                    </nuxt-link>
                </div>
                <div class="show-mobile">
                    <div class="wine-guide-left-title">
                        <nuxt-link class="wine-guide-back"
                                   :to="localePath('/wine-guide/south-africa/stellenbosch')"></nuxt-link>
                        Producers
                    </div>
                    <v-select
                        :items="items"
                        v-model="select"
                        label="Please choose"
                        single-line
                        item-text="report"
                        item-value="src"
                        return-object
                        class="show-mobile show-mobile-select"
                        v-on:change="changeRoute"
                    ></v-select>
                </div>
                <div v-if="$i18n.locale === 'it'" class="wine-guide-right">
                    <div class="howto-title">Tenuta Vinicola Alto</div>
                    <div class="howto-separator"></div>
                    <div class="howto-text">
                        Con sempre più investitori e collezionisti alla ricerca di piccoli, incentrati sulla qualità, non francesi
                        produttori, i vini pregiati sudafricani stanno mostrando segni che anche loro possono essere presi sul serio
                        il sui circuiti del vino investibile. Sconosciute fino a poco tempo fa, le azioni blue-chip (e a
                        Rand debole) stanno rendendo i vini pregiati sudafricani tra i più interessanti sul secondario
                        mercato di rivendita.
                    </div>

                    <div class="howto-title2">Un'icona del Western Cape</div>
                    <div class="howto-text">
                        Una delle tenute che ha lavorato molto duramente per conservare la ripresa delle fortune è Alto, a Stellenbosch. Alto è orgogliosamente la più antica azienda vinicola del Sud Africa e ha una storia che risale al 1693. Come molte altre aziende vinicole sudafricane, Alto ha iniziato come parte di una più grande fattoria conosciuta come Groenrivier (Green River), di proprietà della famiglia Malan. Le viti erano state sulle alte pendici dei monti Helberg fin dall'inizio, ma fu solo con la divisione della fattoria e la successiva vendita (al cognato di Malans) nel 1919 che la tenuta iniziò a raccogliere una seria attenzione sul campo del vino pregiato. Il reimpianto con varietà rosse scelte si è rivelato una mossa saggia per Alto (il nome latino è un riferimento sia all'altitudine del vigneto che alle alte aspirazioni del Malan per il vino). Quando Malan vendette il vigneto a Piet du Toit nel 1959, le viti erano considerate in perfette condizioni e da allora sono stati effettuati pochissimi reimpianti.
                    </div>

                    <div class="howto-title2">Un vino sudafricano superiore</div>
                    <div class="howto-text">
                        L'enologo Schalk Van Der Westhuizen ha assunto le redini nel 2000 Van Der ha avuto un enorme successo
                        Westhuizen è riuscito a spingere Alto nei bicchieri degli ospiti di prima classe della South African Airlines,
                        ottenendo un enorme seguito per il vino. Tuttavia, dopo 15 anni, Van Der Westhuizen ha superato il
                        testimone al figlio Bertho, che è solo il quinto vignaiolo nella storia di Alto. Decisamente sottovalutato
                        - pensate a soli 15€ per una bottiglia di Stellenbosch Cabernet Sauvignon 2015, ma con
                        si fanno investimenti sia in campo che in cantina, aspettatevi prezzi (ergo il già
                        ottima qualità) a crescere nei prossimi anni. Dei cinque vini pregiati prodotti, quattro di
                        loro: il Cabernet Sauvignon, il Merlot e lo Shiraz e il Cabernet Franc se ne sono andati
                        con medaglie d'oro.
                    </div>
                </div>
                <div v-else-if="$i18n.locale === 'de'" class="wine-guide-right">
                    <div class="howto-title">Alto Wine Estate</div>
                    <div class="howto-separator"></div>
                    <div class="howto-text">
                        Immer mehr Investoren und Sammler sind auf der Suche nach kleineren, qualitätsorientierten, nicht-französischen Objekten
                        Produzenten zeigen südafrikanische Spitzenweine Anzeichen dafür, dass auch sie ernst genommen werden können
                        die auf den investierbaren Weinkreisläufen. Bis vor Kurzem noch nie dagewesene Blue-Chip-Aktien (und u. a.).
                        schwacher Rand) machen südafrikanische Spitzenweine zu den interessantesten auf dem Sekundärmarkt
                        Wiederverkaufsmarkt.
                    </div>

                    <div class="howto-title2">Eine Ikone des Westkap</div>
                    <div class="howto-text">
                        Eines der Anwesen, das sehr hart daran gearbeitet hat, den Aufschwung des Vermögens aufrechtzuerhalten, ist Alto in Stellenbosch. Alto ist mit Stolz Südafrikas ältestes Rotweingut und seine Geschichte reicht bis ins Jahr 1693 zurück. Wie viele andere südafrikanische Weingüter begann Alto als Teil einer größeren Farm namens Groenrivier (Green River), die der Familie Malan gehörte. Auf den hohen Hängen des Helberg-Gebirges gab es schon früh Weinreben, aber erst mit der Teilung des Hofes und dem anschließenden Verkauf (an Malans‘ Schwager) im Jahr 1919 begann das Weingut auf dem Gebiet der erlesenen Weine ernsthafte Aufmerksamkeit zu erregen. Die Neubepflanzung mit erlesenen roten Rebsorten erwies sich für Alto als kluger Schachzug (der lateinische Name bezieht sich sowohl auf die Höhenlage des Weinbergs als auch auf die hohen Ansprüche der Malan an den Wein). Als Malan den Weinberg 1959 an Piet du Toit verkaufte, galten die Reben als in einwandfreiem Zustand und seitdem wurden nur sehr wenige Neupflanzungen vorgenommen.
                    </div>

                    <div class="howto-title2">Ein erstklassiger südafrikanischer Wein</div>
                    <div class="howto-text">
                        Im Jahr 2000 übernahm der Winzer Schalk Van Der Westhuizen die Leitung. Sehr erfolgreich, Van Der
                        Westhuizen schaffte es, Alto in die Gunst der First-Class-Gäste der South African Airlines zu befördern.
                        Der Wein hat eine große Fangemeinde gewonnen. Doch nach 15 Jahren bestand Van Der Westhuizen die
                        Der Staffelstab geht an seinen Sohn Bertho, der erst der fünfte Winzer in der Geschichte von Alto ist. Deutlich unterbewertet
                        - Denken Sie an etwa 15 € für eine Flasche Stellenbosch Cabernet Sauvignon 2015, aber mit
                        Investitionen, die sowohl auf den Feldern als auch im Weingut getätigt werden, erwarten Preise (also die bereits
                        hervorragende Qualität) wird in den nächsten Jahren steigen. Von den fünf produzierten erlesenen Weinen sind vier von
                        Sie: der Cabernet Sauvignon, der Merlot und der Shiraz und Cabernet Franc sind alle verschwunden
                        mit Goldmedaillen.
                    </div>
                </div>
                <div v-else-if="$i18n.locale === 'fr'" class="wine-guide-right">
                    <div class="howto-title">Domaine viticole d'Alto</div>
                    <div class="howto-separator"></div>
                    <div class="howto-text">
                        Avec de plus en plus d'investisseurs et de collectionneurs à la recherche de plus petits, axés sur la qualité, non français
                        producteurs, les vins fins sud-africains montrent des signes qu'eux aussi peuvent être pris au sérieux dans
                        le sur les circuits viticoles investissables. Inédits jusqu'à très récemment, les actions de premier ordre (et un
                        faible Rand) font des vins fins sud-africains certains des plus intéressants sur le secondaire
                        marché de la revente.
                    </div>

                    <div class="howto-title2">Une icône du Cap occidental</div>
                    <div class="howto-text">
                        L'un des domaines qui a travaillé très dur pour conserver l'essor des fortunes est Alto, à Stellenbosch. Alto est fièrement le plus ancien domaine viticole rouge d'Afrique du Sud et son histoire remonte à 1693. Comme de nombreux autres domaines viticoles sud-africains, Alto a commencé dans le cadre d'une plus grande ferme connue sous le nom de Groenrivier (Green River), propriété de la famille Malan. Les vignes se trouvaient sur les hautes pentes des montagnes Helberg depuis le début, mais ce n'est qu'à la division de la ferme et à la vente ultérieure (au beau-frère de Malans) en 1919 que le domaine a commencé à attirer sérieusement l'attention sur le domaine des vins fins. La replantation avec des cépages rouges de choix s'est avérée être une décision judicieuse pour Alto (le nom latin fait référence à la fois à l'altitude du vignoble et aux nobles aspirations des Malan pour le vin). Lorsque Malan a vendu le vignoble à Piet du Toit en 1959, les vignes étaient considérées comme en parfait état et très peu de replantations ont été effectuées depuis.
                    </div>

                    <div class="howto-title2">Un vin sud-africain supérieur</div>
                    <div class="howto-text">
                        Le viticulteur Schalk Van Der Westhuizen a repris les rênes en 2000 Grand succès, Van Der
                        Westhuizen a réussi à propulser Alto dans les verres des invités de première classe de South African Airlines,
                        recueillant un énorme succès pour le vin. Cependant, après 15 ans, Van Der Westhuizen passa le
                        le relais à son fils, Bertho, qui n'est que le cinquième vigneron de l'histoire d'Alto. Largement sous-évalué
                        - comptez environ 15 € pour une bouteille de Stellenbosch Cabernet Sauvignon 2015, mais avec
                        investissements réalisés à la fois dans les champs et dans la cave, attendez-vous à des prix (c'est-à-dire déjà
                        excellente qualité) à augmenter au cours des prochaines années. Sur les cinq vins fins produits, quatre de
                        eux : le Cabernet Sauvignon, le Merlot et le Shiraz et le Cabernet Franc sont tous repartis
                        avec des médailles d'or.
                    </div>
                </div>
                <div v-else class="wine-guide-right">
                    <div class="howto-title">Alto Wine Estate</div>
                    <div class="howto-separator"></div>
                    <div class="howto-text">
                        With more and more investors and collectors looking for smaller, quality-focused, non-French
                        producers, South African fine wines are showing signs that they too can be taken seriously in
                        the on the investable wine circuits. Unheard of until very recently, blue-chip stocks (and a
                        weak Rand) are making South African fine wines some of the most interesting on the secondary
                        resale market.
                    </div>

                    <div class="howto-title2">An icon of the Western Cape</div>
                    <div class="howto-text">
                        One of the estates that has been working very hard to conserve the upswing in fortunes is Alto, in Stellenbosch. Alto is proudly South Africa&#39;s oldest red wine estate and has a history dating back as far as 1693. Like many other South African wine estates, Alto started out as part of a larger farm known as Groenrivier (Green River), owned by the Malan family. Vines had been on the high slopes of the Helberg Mountains from an early date, but it was not until the farm’s division and subsequent sale (to Malans’ brother-in-law) in 1919 that the estate began to gather serious attention on the fine wine field. Replanting with choice red varietals proved to be a savvy move for Alto (the Latin name is a reference to both the altitude of the vineyard as well as the Malan’s lofty aspirations for the wine). When Malan sold the vineyard to Piet du Toit in 1959, the vines were considered in perfect condition and very little replanting has been done since.
                    </div>

                    <div class="howto-title2">A superior South African wine</div>
                    <div class="howto-text">
                        Winemaker Schalk Van Der Westhuizen took over the reins in 2000 Hugely successful, Van Der
                        Westhuizen managed to propel Alto into the glasses of South African Airlines first class guests,
                        garnering a huge following for the wine. However, after 15 years, Van Der Westhuizen passed the
                        baton to his son, Bertho, who is just the fifth winemaker in Alto’s history. Vastly underpriced
                        - think around just €15 for a bottle of Stellenbosch Cabernet Sauvignon 2015, but with
                        investments being made in both the fields and the winery, expect prices (ergo the already
                        excellent quality) to rise over the next few years. Of the five fine wines produced, four of
                        them: the Cabernet Sauvignon, the Merlot and the Shiraz and Cabernet Franc have all walked away
                        with gold medals.
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "AltoWineEstate",
    data() {
        return {
            select: {report: 'Alto Wine Estate', src: '/wine-guide/south-africa/stellenbosch/alto-wine-estate'},
            items: [
                {report: 'Alto Wine Estate', src: '/wine-guide/south-africa/stellenbosch/alto-wine-estate'},
                {report: 'Kanonkop Paul Sauer', src: '/wine-guide/south-africa/stellenbosch/kanonkop-paul-sauer'},
                {report: 'Meerlust Estate', src: '/wine-guide/south-africa/stellenbosch/meerlust-estate'},
                {report: 'Savanha Wines', src: '/wine-guide/south-africa/stellenbosch/savanha-wines'},
                {report: 'The Sadie Family Wines', src: '/wine-guide/south-africa/stellenbosch/the-sadie-family-wines'},
                {
                    report: 'Thelema Mountain Vineyards',
                    src: '/wine-guide/south-africa/stellenbosch/thelema-mountain-vineyards'
                }
            ]
        }
    },
    methods: {
        changeRoute(a) {
                this.$router.push({path: this.localePath(a.src) });
            }
    },
    head: {
        title: 'Alto Wine Estate | Vindome Wine Guide',
        meta: [
            {
                hid: 'description',
                name: 'description',
                content: 'Discover the premium wine offerings of Alto Wine Estate, a top producer in the renowned Stellenbosch wine region. Savor their expertly crafted blends, showcasing the best of South African winemaking.'
            }
        ],
        bodyAttrs: {
            class: 'wine-guide inner-page'
        }
    }
}
</script>

<style scoped>
.container {
    max-width: 1170px;
    padding: 0;
    font-family: 'Poppins', sans-serif;
}

.wine-guide-body {
    padding-top: 35px;
}

.wine-guide-left {
    width: 300px;
    display: inline-block;
}

.wine-guide-right {
    display: inline-block;
    width: calc(100% - 305px);
    vertical-align: top;
}

.wine-guide-left-title {
    font-weight: 600;
    color: #024E7B;
    font-size: 18px;
    height: 57px;
    line-height: 57px;
}

.wine-guide-country {
    display: block;
    height: 57px;
    line-height: 57px;
    text-decoration: none;
    color: #000;
    font-size: 16px;
    padding-left: 30px;
    width: 260px;
    border-left: 3px solid transparent;
}

.wine-guide-country:hover,
.wine-guide-country.active {
    border-color: #024E7B;
    background: #E5EDF2;
}
</style>
